import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useLayout } from '~hooks/useLayout';
import { useSeo } from '~hooks/useSeo';
// import { Elements } from '@stripe/react-stripe-js';
import useStripe from '../useStripe';
// import Stripe from './stripe';

import { useDispatch, useSelector } from 'react-redux';

import PaymentActions from '~redux/payment';

// import { gtagReportConversion } from '~helpers/gtagReportConversion';

import './style.scss';

const PaymentProcess = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [sessionId, setSessionId] = useState(null);
  const [contactId, setContactId] = useState(null);

  const [paymentState, setPaymentState] = useState(null);
  
  const [paymentValue, setPaymentValue] = useState(0);
  const [paymentCurrency, setPaymentCurrency] = useState(null);
  const [paymentTransactionId, setPaymentTransactionId] = useState(null);
  

  const [counter, setCounter] = useState(5);

  const domainConfig = useSelector((state) => state.domainConfig);
  
  useLayout({ displayCities: false });
  useSeo(
    intl.formatMessage({
      id: 'containers.payment.subscription_process.title',
    })
  );
  const history = useHistory();

  const { retriveCheckoutSession } = useStripe();

  const retryPayment = async () => {
    dispatch(PaymentActions.toggleRequestModal(true, contactId));
  };

  useEffect(() => {
    const fetchSessionData = async () => {
      const session_Id = new URLSearchParams(window.location.search).get('session_id');
      const if_success = new URLSearchParams(window.location.search).get('success');
      const if_canceled = new URLSearchParams(window.location.search).get('canceled');
      const urlcontactId = new URLSearchParams(window.location.search).get('contactId');
      if(urlcontactId){
        setContactId(urlcontactId)
      }
      

      if (session_Id) {
        setSessionId(session_Id);
        const sessionData = await retriveCheckoutSession(session_Id);
        console.log("sessionData", sessionData);

        if (sessionData.data.payment_status === "paid") {
          setPaymentState(true);
        } else {
          setPaymentState(false);
        }
        setPaymentValue(sessionData.data.amount_total/100);
        setPaymentCurrency(sessionData.data.currency);
        setPaymentTransactionId(sessionData.data.subscription);
      } else {
        setPaymentState(false);
      }
    };

    fetchSessionData();
  }, []);

  useEffect(() => {
    if (paymentState === false && counter > 0) {
      const timer = setTimeout(() => {
        setCounter((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (counter === 0 && paymentState === false) {
      handleRedirection();
    } else if (paymentState === true) {
      handleRedirection(); // Redirect immediately if payment is successful
    }
  }, [counter, paymentState]);

  const handleRedirection = () => {
    // if(domainConfig && domainConfig.gtag && domainConfig.conversionId){
    //   console.log('gtag fired');
    //   gtagReportConversion({
    //     conversionId: domainConfig.gtag,
    //     conversionLabel: domainConfig.conversionId,
    //     value: paymentValue,
    //     currency: paymentCurrency,
    //     transactionId: paymentTransactionId,
    //     redirectUrl: `/discussion/${contactId}`,
    //   });
    // }else{
    //   console.log('gtag not fired');
    //   history.push(`/discussion/${contactId}`);
    // }
    history.push(`/thank-you?returnUrl=/discussion/${contactId}&isChat=true`);
    // history.push(`/discussion/${contactId}`);
  };

  return (
    <div className="payment-process">
      {paymentState === null ? (
        <div>
          <p>
            {intl.formatMessage({
              id: 'containers.payment.subscription_process.retrive',
              defaultMessage: 'Retrieving your payment information...',
            })}
            
          </p>
        </div>
      ) : paymentState === true ? (
        <div>
          <p>
          {intl.formatMessage({
            id: 'containers.payment.subscription_process.payment_successfull',
            defaultMessage: 'Payment successful. Redirecting...',
          })}
            
            {/* <button onClick={handleRedirection}>
            {intl.formatMessage({
              id: 'containers.payment.subscription_process.paid-button',
              defaultMessage: 'Chat with worker',
            })}
            </button> */}
          </p>
        </div>
      ) : (
        <div>
          <p style={{ color: 'red' }}>
          {intl.formatMessage({
            id: 'containers.payment.subscription_process.payment_failed',
            defaultMessage: 'Payment was unsuccessful. ',
          })}
            
            </p>

            <h6>
              {intl.formatMessage({
                id: 'containers.payment.subscription_process.redirecting_in',
                defaultMessage: 'Redirecting in.... ',
              })} <span>{counter}</span>
            </h6>

          {/* <button onClick={retryPayment}>
            {intl.formatMessage({
              id: 'containers.payment.subscription_process.failed-button',
              defaultMessage: 'Retry Payment',
            })}
          </button> */}
        </div>
      )}
    </div>
  );
};

export default PaymentProcess;
